module.exports = __webpack_public_path__ + "assets/img/2.8688ebd2.png";